/* unplugin-vue-components disabled */import script from "./MyOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyOrder.vue?vue&type=script&lang=ts&setup=true"

import "./MyOrder.vue?vue&type=style&index=0&id=743b08f2&lang=less&scoped=true"

import exportComponent from "/Users/zhaoshunchen/Desktop/job/sinosig/workspace/shuke/sinosig-app-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743b08f2"]])

export default __exports__